import isEmpty from 'lodash/isEmpty';
import React from 'react';
import { StyledDesktopText, StyledMobileText } from './SubscribedPanel.styled';
var SubscribedPanelText = function (_a) {
    var mobile = _a.mobile, desktop = _a.desktop;
    var getText = function (text) {
        if (isEmpty(text))
            return null;
        return text === null || text === void 0 ? void 0 : text.split('\n').map(function (p) { return ({ body: p }); });
    };
    // TODO: Refactor this to use clientConfiguration instead.
    var mobileText = getText(mobile);
    var desktopText = getText(desktop);
    return (React.createElement(React.Fragment, null, mobileText === null || mobileText === void 0 ? void 0 :
        mobileText.map(function (p, index) { return (React.createElement(StyledMobileText, { key: +index }, p === null || p === void 0 ? void 0 : p.body)); }), desktopText === null || desktopText === void 0 ? void 0 :
        desktopText.map(function (p, index) { return (React.createElement(StyledDesktopText, { key: +index }, p === null || p === void 0 ? void 0 : p.body)); })));
};
export default SubscribedPanelText;
